import { BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const clearBottomSheetStackAction = (state: BottomSheetState) => {
	state.stack = [];
	state.closeTargetId = null;
};
